import React from "react";
import { useGetStudentCertificates } from "../../hooks/certificateHooks/useCertificates.hooks";
import { StudentCertificates } from "../../Components/StudentCertificate/StudentCertificates";
import { getValue } from "../../utils/object.utils";

interface IProps {
  studentId: number;
}

export const StudentCertificate = ({ studentId }: IProps) => {
  const { isLoading: isStudentCertificatesLoading, data } =
    useGetStudentCertificates({ studentId });

  const studentCertificates = getValue(data, "certifictes", []);

  if (isStudentCertificatesLoading) {
    return <div>Loading certificates...</div>;
  }

  return <StudentCertificates studentCertificates={studentCertificates} />;
};
